module.exports = __webpack_public_path__ + "img/aicad.0a840698.jpg";